/**
 * User Account API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SelfRequestedShare { 
    deviceId: number;
    requestedRole: SelfRequestedShare.RequestedRoleEnum;
}
export namespace SelfRequestedShare {
    export const RequestedRoleEnum = {
        Reader: 'READER',
        DataManager: 'DATA_MANAGER',
        Owner: 'OWNER',
        DeviceManager: 'DEVICE_MANAGER'
    } as const;
    export type RequestedRoleEnum = typeof RequestedRoleEnum[keyof typeof RequestedRoleEnum];
}


